import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAppSelector } from "../../redux/typedHooks";
import { UserInterface } from "../../types/user";

const GuideStepsRedirect: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const user = useAppSelector<UserInterface | null>(state => state.user.currentUser);

  useEffect(() => {
    // Не активуємо редіректи якщо:
    // 1. Немає користувача
    // 2. isShowGuideSteps не активний
    // 3. Користувач не пройшов onboarding (isOnboarding === false)
    // 4. Користувач на сторінці onboarding
    // undefined = показувати гайд (як у GuideSteps); лише explicit false вимикає
    if (!user || user.isShowGuideSteps === false || !user.isOnboarding || location.pathname === "/choose-user-type") {
      return;
    }

    const currentStep = user.currentStepGuide || 1; // За замовчуванням крок 1
    const currentPath = location.pathname;

    // Визначаємо на яку сторінку потрібно редіректити
    let targetPath = "";

    if (currentStep === 1) {
      // Крок 1 - головна сторінка
      targetPath = "/";
    } else if (currentStep === 2 || currentStep === 3) {
      // Кроки 2 та 3 - сторінка профілю
      targetPath = "/OctaviaSolana";
    } else {
      // Якщо крок більший за 3 або менший за 1, не редіректимо
      return;
    }

    // Якщо ми не на потрібній сторінці, редіректимо
    // Додаємо невелику затримку щоб уникнути конфліктів з оновленням DOM
    if (targetPath && currentPath !== targetPath) {
      // Використовуємо setTimeout щоб дати час компонентам оновитися
      const timeoutId = setTimeout(() => {
        history.push(targetPath);
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [user, location.pathname, history]);

  return null;
};

export default GuideStepsRedirect;

